module.exports = __webpack_public_path__ + "static/media/searchIcon.2ba51a96.svg";